const flow = (arg, firstFn, ...fns) => {
  if (!firstFn) {
    throw new TypeError("pipe requires at least one function");
  }
  return fns.reduce((acc, fn) => fn(acc), firstFn(arg));
};
export {
  flow
};
